// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import DateRange from '../core/date-range';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import Permissions from '../core/permissions';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './rules.scss';

const servicesDataKey = 'rules';

class Rules extends Component {
    rulesContainer = React.createRef();

    getColumnConfig() {
        return [
            {
                dataKey: 'ruleId',
                title: 'ID',
                width: '8%',
            },
            {
                dataKey: 'name',
                link: '/rules',
                linkKey: 'ruleId',
                title: 'Name',
                type: 'link',
                width: '40%',
            },
            {
                dataKey: 'category',
                title: 'Category',
                width: '12%',
            },
            {
                dataKey: 'status',
                title: 'Status',
                width: '16%',
            },
            {
                dataKey: 'dateCreated',
                title: 'Date Created',
                type: 'date',
                width: '12%',
            },
            {
                dataKey: 'lastUpdated',
                title: 'Last Update',
                type: 'date',
                width: '12%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: ['dateCreated', 'lastUpdated', 'ruleId', 'name', 'category', 'status', 'version'],
        };
    }

    getTablewithsortProps() {
        return {
            activeRowValueKey: 'routerParams.ruleId',
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            updateOnUrlChange: false,
            ...this.props,
        };
    }

    renderDetail = (searchData) => (
        <pre className="rules--record-detail" style={{maxWidth: this.rulesContainer.current.offsetWidth}}>
            {searchData.rule}
        </pre>
    );

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Name" name="name" title="Use wildcard (*) for partial name match" />
            <Permissions adminOnly={true}>
                <Select label="Category" name="category">
                    <option value="">Filter by Category</option>
                    <option value="AUTO_MAP">Auto Map</option>
                    <option value="ENRICH">Enrich</option>
                    <option value="EST">EST</option>
                    <option value="IVI">IVI</option>
                    <option value="PRE_PROD">Pre Prod</option>
                    <option value="VALIDATION">Validation</option>
                </Select>
            </Permissions>
            <Select label="Status" name="status">
                <option value="">Filter by Status</option>
                <option value="CURRENT">Current</option>
                <option value="INACTIVE">Inactive</option>
            </Select>
            <DateRange label="Created" name="dateCreated" />
            <DateRange label="Last Updated" name="lastUpdated" />
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        const {searchData} = this.props;

        return (
            <div className="rules" ref={this.rulesContainer}>
                <ServicesExportPanelAction searchData={searchData} />
                <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                <SearchPagination {...this.getPaginationProps()} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        );
    }
}

Rules.propTypes = {
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(Rules, servicesDataKey);
